import { database } from './firebase'
import { ref, child, query, orderByChild, equalTo, get, set } from 'firebase/database'

const setScores = (id, mode, res) => {
  return new Promise((resolve, reject) => {
    // Validar que res sea un array válido
    if (!res || !Array.isArray(res) || res.length === 0) {
      resolve() // No hay resultados que procesar
      return
    }
    
    const dbRef = ref(database, 'grupos')
    const groups = []
    const promises = []
    const results = res.map((result) => {
      if (typeof result.gLocal !== 'number' || typeof result.gVisitante !== 'number') {
        return undefined
      } else if (result.gLocal > result.gVisitante) {
        return 'l'
      } else if (result.gLocal < result.gVisitante) {
        return 'v'
      } else {
        return 'e'
      }
    })
    const groupsQuery = query(child(dbRef, 'index'), orderByChild('mode'), equalTo(mode))
    get(groupsQuery)
      .then((snap) => {
        snap.forEach((child) => {
          groups.push(child.key)
        })
        groups.forEach((group, i) => {
          const scores = {}
          const globalScores = {}
          const members = []
          promises[i] = new Promise((resolve, reject) => {
            get(child(dbRef, 'resultados/' + group + '/' + id))
              .then((snap) => {
                snap.forEach((child) => {
                  scores[child.key] = 0
                  child.val().forEach((result, i) => {
                    if (result === results[i]) {
                      scores[child.key]++
                    }
                  })
                })
                return set(child(dbRef, 'puntaje/' + group + '/quiniela/' + id), scores)
              })
              .then(() => {
                return get(child(dbRef, 'miembros/' + group))
              })
              .then((snap) => {
                snap.forEach((child) => {
                  members.push(child.key)
                  globalScores[child.key] = 0
                })
                return get(child(dbRef, 'puntaje/' + group + '/quiniela'))
              })
              .then((snap) => {
                snap.forEach((child) => {
                  members.forEach((member) => {
                    globalScores[member] += child.val()[member] ? child.val()[member] : 0
                  })
                })
                return set(child(dbRef, 'puntaje/' + group + '/global'), globalScores)
              })
              .then(() => {
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          })
        })
        return Promise.all(promises)
      })
      .then(() => {
        resolve()
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default setScores
